import React, { Component } from 'react';
export default class DropdownButton extends Component {
	
	state = {clicked:false, hover:false}

	render() {
		const{text, isActive, selectedValue} = this.props;
		const{clicked, hover} = this.state;

		const hasValue = selectedValue === 'none' || selectedValue === '';

		const style = {...this.props.style,
			transition:"background 0.2s ease-out",		
			padding: hasValue ? "8px 16px 8px 16px" : "6px 16px 6px 16px",
			borderRadius: 40,
			backgroundColor: clicked || hover ? global.colorTheme.secondaryLight : hasValue ? global.colorTheme.main : 'white',
			border: `2px solid ${clicked ? 'black' : global.colorTheme.main}`,
			opacity: isActive ? 1 : 0.3,
			cursor: global.isMobile ? "" : "pointer",
			pointerEvents: isActive ? "auto" : "none",
			color: hasValue ? 'white' : global.colorTheme.main,
			fontSize:20,
			fontFamily: hasValue ? "simplerReg" : "simplerBlack",
			whiteSpace: 'nowrap', 
			overflow: 'hidden', 
			textOverflow:'ellipsis',
		}
		return <div style={style} onClick= {this.props.onClick} 
		
		onMouseEnter={() => {
			this.setState({hover:true})
		}} onMouseLeave={() => {
			this.setState({hover:false, clicked:false})
		}} onMouseDown={()=>{
			this.setState({clicked:true, hover:false})
		}} onMouseUp={()=>{
			this.setState({clicked:false, hover:false})
		}}
		
		onTouchCancel={() => {
			this.setState({clicked:false})
		}} onTouchStart={()=>{
			this.setState({clicked:true})
		}} onTouchEnd={()=>{			
			this.setState({clicked:false})
		}}> 
			<span style={{marginLeft:8}}> {text} </span>
			<span> {!hasValue ? selectedValue : '⋯'} </span>
	  	</div>
	}
}



// WEBPACK FOOTER //
// ./src/Comp/Shared/DropdownButton.js